import script from "./Tema.vue?vue&type=script&setup=true&lang=js"
export * from "./Tema.vue?vue&type=script&setup=true&lang=js"

import "./Tema.vue?vue&type=style&index=0&id=796a78a2&lang=scss"

const __exports__ = script;

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QPageSticky});
